import { createFileRoute } from '@tanstack/react-router';
import ClockingRecs, {
  clockingRecsConfiguration,
  preloadClockingRecs,
} from 'containers/ClockingRecs';
import { prefetchGridSchema } from '../-utils/loaders';

export const Route = createFileRoute('/_authenticated/clockingRecs')({
  loader: ({ context }) => {
    prefetchGridSchema(
      context.queryClient,
      clockingRecsConfiguration.itemType
    );
    return preloadClockingRecs(context.queryClient);
  },
  component: ClockingRecs,
});
